module.exports = __webpack_public_path__ + "static/media/btt.1b7e97fb.svg";